export const REFERER_OFFER = 'referreroffer';
export const ORDER_TRACKING = 'order';
export const REFERER_FIND = 'refereefind';
export const DASHBOARD = 'dashboard';
export const SEGMENT_FOR_MENTION_ME = 'segmentForMentionMe';
